module.exports = __webpack_public_path__ + "static/media/search_money.39da8d5f.svg";